import IncomingButtons from '../callingButtons/IncomingButtons'
import { getShortName, humanize } from '../../../../../../itrust_common/components/HelperFunctions'
import { connect, useDispatch } from 'react-redux'
import { voipActiveCallPopUp } from '../../../../../../redux/actions/addOns/voip/voipActions'
import ActiveCallButtons from '../callingButtons/ActiveCallButtons'
import CallTimer from '../CallTimer'

function PopUpScreen(props) {
  const { callInfo, telecomServiceType, handleMakeOutGoingCall, staffId, activeCallLog, activeCallType, call_start_time } = props
  const dispatch = useDispatch()

  return (
    <div className='p-4'>
      <div className='d-flex justify-content-between'>
        <div className='d-flex align-items-baseline'>
          <h6 className='text-danger mb-2 mr-3'>{`${humanize(activeCallType)} Call`} - </h6>
          <p className='mb-0 mr-4'>{humanize(callInfo?.callStatus)}</p>
          <CallTimer callStatus={callInfo.callStatus} call_start_time={call_start_time} className="mb-0" />
        </div>
        <i class="las la-times-circle text-primary font-size-20 pointer" onClick={() => dispatch(voipActiveCallPopUp(false))}></i>
      </div>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='d-flex align-items-center'>
          {getShortName(callInfo?.isAnonymous ? { name: 'A' } : { name: activeCallLog.patient_name }, 'mr-4 width-4 height-4', 'mr-4 width-4 height-4 font-size-24 ')}
          <div className='d-flex flex-column'>
            {callInfo?.isAnonymous ?
              <strong>Anonymous</strong> :
              <strong>
                {activeCallLog?.patient_name}
                {/* <Link to={`/patients/${activeCallLog?.patient_id}/overview`} className="btn-link">
                  <i className="las la-external-link-alt text-primary"></i>
                </Link> */}
              </strong>
            }
            <span>
              {activeCallLog == 'outgoing' ? activeCallLog?.from : activeCallLog?.to}
            </span>
          </div>
        </div>
        <div className='d-flex align-items-center'>
          {(callInfo?.callStatus === 'call_started') && <ActiveCallButtons call={callInfo.call} telecomServiceType={telecomServiceType} />}
          <IncomingButtons
            staffId={staffId}
            callInfo={callInfo}
            dispatch={dispatch}
            call={callInfo?.call}
            isCallActive={callInfo?.isCallActive}
            isAnonymous={callInfo?.isAnonymous}
            telecomServiceType={telecomServiceType}
          // handleMakeOutGoingCall={() => handleMakeOutGoingCall()}
          />
        </div>
      </div>
    </div>
  )
}


const mapStateToProps = state => {
  const { voip } = state;

  return {
    activeCallLog: voip.calling_info.incoming_info?.call_log_id ? voip.calling_info.incoming_info : voip.calling_info.call_log, // incoming_call ? incoming_call : outgoing_call
    activeCallType: voip.calling_info.incoming_info?.call_log_id ? 'incoming' : 'outgoing',
    call_start_time: voip?.call_start_time,
  }
}

export default connect(mapStateToProps)(PopUpScreen);